import React, { Component } from 'react';
import "./NavbarStyles.css"; // Importing styles for Navbar
import { MenuItems } from './MenuItems';
import { Link } from 'react-router-dom';

export class Navbar extends Component {
    state = { clicked: false }

    handleClick = () => {
        this.setState({ clicked: !this.state.clicked });
    }

    render() {
        return (
            <nav className='NavbarItems'>
                <h1 className='navbar-logo'>Marocaine Travel</h1>

                <div className='menu-icons' onClick={this.handleClick}>
                    <i className={this.state.clicked ? "fas fa-times" : "fas fa-bars"}></i>
                </div>

                <ul className={this.state.clicked ? "nav-menu active" : "nav-menu"}>
                    {MenuItems.map((item, index) => (
                        <li key={index}>
                            <Link className={item.cName} to={item.url}>
                                <i className={item.icon}></i>
                                {item.title}
                            </Link>
                        </li>
                    ))}
                    {/* Place the button outside the mapping */}
                    <li>
                        <button>Sign Up</button>
                    </li>
                </ul>
            </nav>
        );
    }
}

export default Navbar;
